import React from "react";

interface PageTitleProps {
  children?: React.ReactNode;
  headingPart1?: string;
  headingPart2?: string;
}

const PageTitle: React.FC<PageTitleProps> = ({
  children,
  headingPart1 = "",
  headingPart2 = "",
}) => {
  return (
    <div className="row mb-5">
      <div className="d-flex flex-column flex-md-row align-items-md-center gap-2">
        <div className="flex-md-fill">
          <h3>
            <span className="me-1">{headingPart1}</span>
            <span className="fs-1 text-bold">{headingPart2}</span>
          </h3>
        </div>
        <div className="d-flex flex-column gap-2">
          {children}
        </div>
      </div>
    </div>
  );
};

export default PageTitle;
